const config = {
	env: {
		base_url: process.env.BASE_URL,
		node_env: process.env.NODE_ENV
	},
	routeMode: 'history', //hash 模式 history 模式
	api: {
		host: 'http://api.gzcanr.com',
		crossDomain: true,
		timeout: 60000
	},
	cookie: {
		TokenKey: 'Gzcanr-Token',
		setting: {
			domain: 'gzcanr.com',
			expires: 1,
			path: '/',
			secure:false
		}
	},
	domain: {
		app: 'http://www.gzcanr.com',
		master: 'http://master.gzcanr.com'
	}
}


export default config




// WEBPACK FOOTER //
// ./src/config/app.js